import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { useAgentAuthStore } from '@/stores/agentAuth'

// ✅ 定义 Agent 用户资料类型（根据你 /agent/me 返回结构调整）
interface AgentInfo {
  username: string
  uid: string
  share: number
  wallet_balance: number
  referral_code?: string
  profit_share?: number
  share_base?: number
  date?: string
}

export const useAgentAuthStore = defineStore('agentAuth', () => {
  // ✅ 强类型存储 Agent 资料
  const agent = useStorage<AgentInfo | null>('agent', null)
  const ready = useStorage('ready', false)
  const sessionChecked = useStorage('sessionChecked', false)

  function setAgent(data: AgentInfo) {
    agent.value = data
    sessionChecked.value = true
  }

  function clearAgent() {
    agent.value = null
    ready.value = false
    sessionChecked.value = false
  }

  function setReady(value: boolean) {
    ready.value = value
  }

  function setSessionChecked(value: boolean) {
    sessionChecked.value = value
  }

  return {
    agent,
    ready,
    sessionChecked,
    setAgent,
    clearAgent,
    setReady,
    setSessionChecked
  }
})
